import { createUseStyles } from "react-jss";
import checkIcn from "assets/images/check.svg";
export const useStyles = createUseStyles({
  timeline: {
    paddingLeft: "40px",
    "&:before": {
      content: '""',
      width: "2px",
      height: "100%",
      backgroundColor: "rgb(var(--light))",
      position: "absolute",
      left: "16px",
      top: "4px",
    },
    "& .timel__items": {
      "&:not(:last-child)": {
        marginBottom: "20px",
      },
      "& .timel__num": {
        top: "-4px",
        left: "-36px",
        width: "26px",
        height: "26px",
        fontSize: "13px",
        color: "rgb(var(--gray) / 0.50)",
        boxShadow: "0 0 0 5px rgb(var(--white))",
      },
      "& .timel__content": {
        "& .timel__head": {
          fontSize: "15px",
          lineHeight: "20px",
        },
        "& .timel__body": {
          marginBlock: "10px",
          // qtype__one
          "& .qtype__one": {
            padding: "16px",
            borderRadius: "8px",
            border: "1px solid rgb(var(--light))",
            "& p": {
              fontSize: "14px",
              lineHeight: "24px",
              color: "rgb(var(--gray))",
              marginBottom: "0",
            },
          },
          // qtype__two
          "& .qtype__two": {
            padding: "16px",
            borderRadius: "8px",
            border: "1px solid rgb(var(--light))",
            "& .multi__list": {
              display: "grid",
              columnGap: "24px",
              rowGap: "10px",
              gridTemplateColumns: "1fr 1fr 1fr",
              listStyle: "none",
              "& > li": {
                fontSize: "14px",
                paddingLeft: "16px",
                color: "rgb(var(--gray))",
                "&:not(.active):before": {
                  content: '""',
                  width: "4px",
                  height: "4px",
                  borderRadius: "50rem",
                  backgroundColor: "rgb(var(--gray))",
                  position: "absolute",
                  top: "9px",
                  left: "0",
                },
                "&.active": {
                  color: "rgb(var(--dark))",
                  fontWeight: "var(--fw-500)",
                  "&:before": {
                    content: '""',
                    width: "18px",
                    height: "14px",
                    backgroundImage: `url(${checkIcn})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    position: "absolute",
                    top: "4px",
                    left: "-4px",
                  },
                },
              },
            },
          },
          // qtype__three
          "& .qtype__three": {
            borderRadius: "8px",
            border: "1px solid rgb(var(--light))",
            "& .table": {
              borderRadius: "8px",
              "& > thead": {
                "& > tr": {
                  "& > th": {
                    fontSize: "14px",
                    color: "rgb(var(--dark))",
                    fontWeight: "var(--fw-500)",
                    backgroundColor: "#F5F7FA",
                    borderColor: "#E9EDF2",
                  },
                },
              },
              "& > tbody": {
                "& > tr": {
                  "& > td": {
                    fontSize: "14px",
                    color: "rgb(var(--gray))",
                    borderColor: "#E9EDF2",
                  },
                  "&:nth-of-type(odd)": {
                    "& > *": {
                      boxShadow: "none",
                      backgroundColor: "rgb(var(--white))",
                    },
                  },
                  "&:nth-of-type(even)": {
                    "& > *": {
                      boxShadow: "none",
                      backgroundColor: "#F5F7FA",
                    },
                  },
                  "&:last-child": {
                    "& > td": {
                      borderBottom: "0",
                      "&:first-child": {
                        borderBottomLeftRadius: "8px",
                      },
                      "&:last-child": {
                        borderBottomRightRadius: "8px",
                      },
                    },
                  },
                },
              },
            },
          },
          // qtype__four
          "& .qtype__four": {
            padding: "16px",
            borderRadius: "8px",
            border: "1px solid rgb(var(--light))",
            "& p": {
              fontSize: "14px",
              lineHeight: "24px",
              color: "rgb(var(--gray))",
              marginBottom: "0",
            },
          },
          // qtype__five
          "& .qtype__five": {
            padding: "16px",
            borderRadius: "8px",
            border: "1px solid rgb(var(--light))",
            "& .asseqt__list": {
              listStyle: "none",
              "& > li": {
                fontSize: "14px",
                paddingLeft: "16px",
                color: "rgb(var(--gray))",
                "&:not(:last-child)": {
                  marginBottom: "10px",
                },
                "&:not(.active):before": {
                  content: '""',
                  width: "4px",
                  height: "4px",
                  borderRadius: "50rem",
                  backgroundColor: "rgb(var(--gray))",
                  position: "absolute",
                  top: "9px",
                  left: "0",
                },
                "&.active": {
                  color: "rgb(var(--dark))",
                  fontWeight: "var(--fw-500)",
                  "&:before": {
                    content: '""',
                    width: "18px",
                    height: "14px",
                    backgroundImage: `url(${checkIcn})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    position: "absolute",
                    top: "4px",
                    left: "-4px",
                  },
                },
              },
            },
            "& .qtype__card": {
              padding: "16px",
              borderRadius: "8px",
              border: "1px solid rgb(var(--light))",
              "& p": {
                fontSize: "14px",
                lineHeight: "24px",
                marginBottom: "0",
              },
            },
          },
          // qtype__six
          "& .qtype__six": {
            paddingBlock: "10px",
            "& .range__slider": {
              "& > p": {
                fontSize: "12px",
                position: "relative",
                top: "-3px",
              },
              "& .form-range": {
                fontSize: "14px",
                lineHeight: "24px",
                color: "rgb(var(--gray))",
                marginBottom: "0",
                position: "relative",
                "&::-webkit-slider-thumb": {
                  WebkitAppearance: "none",
                  appearance: "none",
                  width: "24px",
                  height: "24px",
                  borderRadius: "50rem",
                  backgroundColor: "rgb(var(--white))",
                  border: "1px solid rgb(var(--success))",
                  boxShadow: "0 0 10px rgb(var(--dark) / 0.20)",
                  cursor: "pointer",
                  position: "relative",
                  top: "-4px",
                },
                "&::-moz-range-thumb": {
                  width: "24px",
                  height: "24px",
                  borderRadius: "50rem",
                  backgroundColor: "rgb(var(--white))",
                  border: "1px solid rgb(var(--success))",
                  boxShadow: "0 0 10px rgb(var(--dark) / 0.20)",
                  cursor: "pointer",
                  position: "relative",
                  top: "-4px",
                },
              },
              "& .slider-tooltip": {
                marginTop: "23px",
                marginLeft: "-0.25%",
                fontSize: "12px",
                color: "rgb(var(--success)) !important",
              },
            },
          },
        },
      },
      "&:hover": {
        "& .timel__num": {
          animation: "org__pop 0.4s linear infinite",
          color: "rgb(var(--gray) / 0.90)",
        },
      },
    },
  },
});
